import { render, staticRenderFns } from "./GetProcesses.vue?vue&type=template&id=3e379736"
import script from "./GetProcesses.vue?vue&type=script&lang=js"
export * from "./GetProcesses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports